import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Droplet = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.24h42V22H4z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.602 2.447a.989.989 0 00-1.21-.001C9.51 3.879 3.973 8.547 4 14c0 4.411 3.589 8 8 8 4.412 0 8-3.589 8-7.995.027-5.365-5.533-10.116-7.398-11.558",
    clipPath: "url(#b)"
  }));
});
Droplet.displayName = 'Droplet';
export var DropletDimensions = {
  height: 24,
  width: 24
};